module.exports = __webpack_public_path__ + "static/media/heart-icon-sm.42da1c55.svg";